// Encart "Cette enquête existe en pack" — snippets/pack-upsell.liquid
if (!customElements.get('pack-upsell')) {
  customElements.define('pack-upsell', class PackUpsell extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-pack-add]');
      if (this.button) this.button.addEventListener('click', this.addToCart.bind(this));
    }

    addToCart() {
      const btn = this.button;
      btn.setAttribute('aria-busy', 'true');

      fetch(theme.routes.cartAdd, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(this.dataset.variantId), quantity: 1 }] })
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 422 || data.status === 'bad_request') {
            if (data.description) console.error('[pack-upsell]', data.description);
            return;
          }

          if (theme.settings.cartType !== 'dropdown') {
            window.location.href = theme.routes.cartPage;
            return;
          }

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: data.items ? data.items[0] : data, addToCartBtn: btn }
          }));
        })
        .catch((error) => console.error('[pack-upsell]', error))
        .finally(() => btn.removeAttribute('aria-busy'));
    }
  });
}
